
// import { useQuery } from '@tanstack/react-query';
// import { serviceServices } from '../services/service.service';

// /**
//  * Reusable API error parser
//  */
// const parseApiError = (error) => {
//   return {
//     message:
//       error?.response?.data?.message ||
//       error?.response?.data?.error ||
//       error?.message ||
//       'Something went wrong',

//     status: error?.response?.status || 500,

//     errors: error?.response?.data?.errors || [],
//   };
// };

// /**
//  * Get all services
//  */
// export const useServices = ({
//   page,
//   limit,
//   isActive,
//   approvalStatus,
//   search,
//   categoryId,
//   sortBy,
//   sortOrder,
// }) => {
//   return useQuery({

//     queryKey: [
//       'services',
//       {
//         page,
//         limit,
//         isActive,
//         approvalStatus,
//         search,
//         categoryId,
//         sortBy,
//         sortOrder,
//       },
//     ],

//     queryFn: async () => {
//       try {

//         return await serviceServices.getServices({
//           page,
//           limit,
//           isActive,
//           approvalStatus,
//           search,
//           categoryId,
//           sortBy,
//           sortOrder,
//         });

//       } catch (error) {
//         throw parseApiError(error);
//       }
//     },

//     staleTime: 0,

//     gcTime: 0,

//     retry: 1,

//     refetchOnWindowFocus: false,
//   });
// };

import { useQuery } from '@tanstack/react-query';
import { serviceServices } from '../services/service.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all services
 */
export const useServices = ({
  page,
  limit,
  isActive,
  approvalStatus,
  search,
  categoryId,
  subcategoryId,
  sellerId,
  sortBy,
  sortOrder,
}) => {
  return useQuery({
    queryKey: [
      'services',
      {
        page,
        limit,
        isActive,
        approvalStatus,
        search,
        categoryId,
        subcategoryId,
        sellerId,
        sortBy,
        sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        return await serviceServices.getServices({
          page,
          limit,
          isActive,
          approvalStatus,
          search,
          categoryId,
          subcategoryId,
          sellerId,
          sortBy,
          sortOrder,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 0,
    gcTime: 0,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};